const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const TELEGRAM_RE = /^[A-Za-z0-9_]{5,32}$/;

export const HOMEPAGE_LEAD_ERRORS = {
  name: 'Укажите имя',
  phone: 'Укажите номер с кодом страны',
  email: 'Укажите корректный e-mail',
  telegram: 'Укажите ник латиницей, 5-32 символа',
  consent: 'Нужно согласие на обработку данных',
};

export function normalizePhone(raw) {
  const trimmed = String(raw || '').trim();
  const digits = trimmed.replace(/\D/g, '');
  if (!digits) return null;

  let normalized = digits;
  if (normalized.length === 11 && normalized.startsWith('8')) {
    normalized = `7${normalized.slice(1)}`;
  }

  if (normalized.startsWith('7')) {
    return normalized.length === 11 ? `+${normalized}` : null;
  }

  if (trimmed.startsWith('+') && normalized.length >= 8 && normalized.length <= 15) {
    return `+${normalized}`;
  }

  return null;
}

export function normalizeTelegram(raw) {
  const value = String(raw || '').trim().replace(/^@+/, '');
  if (!TELEGRAM_RE.test(value)) return null;
  return value;
}

export function buildHomepageLeadSubmission(input) {
  const name = String(input.name || '').trim();
  const task = String(input.task || '').trim();
  const method = input.contactMethod;
  const errors = {};

  if (!name) errors.name = HOMEPAGE_LEAD_ERRORS.name;

  let contact = null;
  if (method === 'phone') {
    contact = normalizePhone(input.contact);
    if (!contact) errors.contact = HOMEPAGE_LEAD_ERRORS.phone;
  } else if (method === 'email') {
    const email = String(input.contact || '').trim();
    if (!EMAIL_RE.test(email)) errors.contact = HOMEPAGE_LEAD_ERRORS.email;
    else contact = email;
  } else if (method === 'telegram') {
    contact = normalizeTelegram(input.contact);
    if (!contact) errors.contact = HOMEPAGE_LEAD_ERRORS.telegram;
  } else {
    errors.contact = HOMEPAGE_LEAD_ERRORS.phone;
  }

  if (input.consent !== true) errors.consent = HOMEPAGE_LEAD_ERRORS.consent;

  if (Object.keys(errors).length > 0) {
    return { ok: false, errors, payload: null };
  }

  return {
    ok: true,
    errors: {},
    payload: {
      contactName: name,
      contactType: method,
      contact,
      calculatorData: {
        requestType: 'homepage_lead',
        leadSource: input.source,
        contactMethod: method,
        ...(task ? { taskDescription: task } : {}),
      },
    },
  };
}
